import { render, staticRenderFns } from "./DashboardGrid.vue?vue&type=template&id=34ffa9ec&scoped=true"
import script from "./DashboardGrid.vue?vue&type=script&lang=js"
export * from "./DashboardGrid.vue?vue&type=script&lang=js"
import style0 from "./DashboardGrid.vue?vue&type=style&index=0&id=34ffa9ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ffa9ec",
  null
  
)

export default component.exports